import React from 'react'
import Pill from './Pill'

interface DatePillProps {
  date: string | Date
  className?: string
  style?: React.CSSProperties
}

const DatePill: React.FC<DatePillProps> = ({ date, className, style }) => {
  const formattedDate = new Date(date).toLocaleDateString('de-DE', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })

  return (
    <Pill className={className} style={style} variant="primary">
      <time>{formattedDate}</time>
    </Pill>
  )
}

export default DatePill
